var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.0889fc9de81eb0deb86e80ad42642322.svg#F';
                    var viewUrl = 'sprites.0889fc9de81eb0deb86e80ad42642322.svg#view-F';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 29 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };